import React, {Component} from 'react';
import {
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    FlatList,
    I18nManager,
    Image,
    BackHandler,
    Alert,
    Platform,
    KeyboardAvoidingView
} from 'react-native';
import {moderateScale} from "../../../../../tools/Scaling";
import Colors from "../../../../../tools/Colors";
import HMTextView from "../../../../../customviews/HMTextView";
import i18n from "../../../../../I18n/i18n";
import store from "../../../../../redux/store";
import HMTextInput from "../../../../../customviews/HMTextInput";
import * as NavigationService from "../../../../../redux/NavigationService";
import {typeExport} from "../../../../../redux/store/type";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import moment from "moment-jalaali";
import {serviceActionListNotSendRegisterComplaints} from "../../../splash/action/ActionSplashGetAllData";
import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../../customviews/HMActionBar";
import HMItemCategory from "../../../../../customviews/HMItemCategory";
import Steps from "../../../../../customviews/steps/Steps";
import HMIcon from "../../../../../customviews/HMIcon";
import HMAlert from "../../../../../customviews/HMAlert";

const PAGES = ['Page 1', 'Page 2', 'Page 3', 'Page 4', 'Page 5'];

const firstIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 40,
    separatorStrokeWidth: 3,
    currentStepStrokeWidth: 5,
    separatorFinishedColor: '#4aae4f',
    separatorUnFinishedColor: '#a4d4a5',
    stepIndicatorFinishedColor: '#4aae4f',
    stepIndicatorUnFinishedColor: '#a4d4a5',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 15,
    currentStepIndicatorLabelFontSize: 15,
    stepIndicatorLabelCurrentColor: '#000000',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: 'rgba(255,255,255,0.5)',
    labelColor: '#666666',
    labelSize: 12,
    currentStepLabelColor: '#4aae4f',
};

const secondIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 30,
    separatorStrokeWidth: 2,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: '#fe7013',
    stepStrokeWidth: 3,
    separatorStrokeFinishedWidth: 4,
    stepStrokeFinishedColor: '#fe7013',
    stepStrokeUnFinishedColor: '#aaaaaa',
    separatorFinishedColor: '#fe7013',
    separatorUnFinishedColor: '#aaaaaa',
    stepIndicatorFinishedColor: '#fe7013',
    stepIndicatorUnFinishedColor: '#ffffff',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 13,
    currentStepIndicatorLabelFontSize: 13,
    stepIndicatorLabelCurrentColor: '#fe7013',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: '#aaaaaa',
    labelColor: '#999999',
    labelSize: 13,
    currentStepLabelColor: '#fe7013',
};

const thirdIndicatorConfigs = {
    stepIndicatorSize: 25,
    currentStepIndicatorSize: 30,
    separatorStrokeWidth: 2,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: '#7eaec4',
    stepStrokeWidth: 3,
    stepStrokeFinishedColor: '#7eaec4',
    stepStrokeUnFinishedColor: '#dedede',
    separatorFinishedColor: '#7eaec4',
    separatorUnFinishedColor: '#dedede',
    stepIndicatorFinishedColor: '#7eaec4',
    stepIndicatorUnFinishedColor: '#ffffff',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 0,
    currentStepIndicatorLabelFontSize: 0,
    stepIndicatorLabelCurrentColor: 'transparent',
    stepIndicatorLabelFinishedColor: 'transparent',
    stepIndicatorLabelUnFinishedColor: 'transparent',
    labelColor: '#999999',
    labelSize: 13,
    currentStepLabelColor: '#7eaec4'
};
let stringListName = '';
let container = null;

const getStepIndicatorIconConfig = ({position, stepStatus}) => {
    const iconConfig = {
        name: 'feed',
        color: stepStatus === 'finished' ? '#ffffff' : '#fe7013',
        size: 15
    };
    switch (position) {
        case 0: {
            iconConfig.name = 'shopping-cart';
            break
        }
        case 1: {
            iconConfig.name = 'location-on';
            break
        }
        case 2: {
            iconConfig.name = 'assessment';
            break
        }
        case 3: {
            iconConfig.name = 'payment';
            break
        }
        case 4: {
            iconConfig.name = 'track-changes';
            break
        }
        default: {
            break
        }
    }
    return iconConfig
};
export default class RegisterComplaintsScreen extends Component {
    constructor(props) {
        super(props);
        container = this;
        stringListName = '';
        //let listMenus=  store.getState().reducerSplashGetAllData.resultsSaina.result.list.find(({type}) => type == this.props.route.params.item.type).subjects;
        let listMenus = store.getState().reducerSplashGetAllData.resultsSaina.result.list.find(({type}) => type == 7).subjects;
        let listPlace = store.getState().reducerSplashGetAllData.resultsSaina.result.places;
        this.state = {
            currentPage: 0,

            indexSelectedArray1: -1,
            itemSelectedArray1: null,

            itemSelectedArray1Sub: null,
            indexSelectedArray1Sub: -1,

            indexSelectedArray2: -1,
            itemSelectedArray2: null,


            indexSelectedArray2Sub: -1,
            itemSelectedArray2Sub: null,


            pageDataArray1Sub: [],
            pageDataArray2: [],
            pageDataArray2Sub: [],
            typeButton: "next",
            name: '',
            description: '',
            arrData: [],
            listName: []
        }

        //this.pageDataArray = ['گروه موضوع', 'زیر گروه', 'منطقه', 'نوع منطقه', 'درج توضیحات'];
        this.pageDataArray = ['', '', '', '', ''];

        this.pageDataArray1 = listMenus

        this.pageDataArray2 = listPlace


    }

    componentDidMount() {
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {
        if (this.state.currentPage >= 1) {
            this.setState({currentPage: this.state.currentPage - 1, typeButton: "back"}
                , () => {

                }
            )
        } else {
            NavigationService.Pop();
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (nextState.currentPage !== this.state.currentPage) {
            if (this.viewPager) {
                this.viewPager.setPage(nextState.currentPage)
            }
        }
    }

    async setData() {
        let {token} = store.getState().reducerSplashGetAllData
        let {item} = this.props.route.params
        if (this.state.listName.length > 0)
            this.state.listName.map((item, index) => {
                if ((this.state.listName.length - 1) == index)
                    stringListName += (item)
                else
                    stringListName += (item + ',')
            })


        //////////////////////
        let listMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyRegisterComplaintsOffline + item.type);
        //////////////////////


        if (store.getState().reducerSplashGetAllData.Connection) {
            let paramss = {
                "_operation": typeExport._Contacts,
                "mode": "SaveComplaint",
                "lang": i18n.locale,
                "token": token,
                "type": item.type,
                // "ticket_title": this.state.itemSelectedArray1Sub == null ? null : this.state.itemSelectedArray1Sub.name,

                "topicId": this.state.itemSelectedArray1Sub == null ? this.state.itemSelectedArray1.id : this.state.itemSelectedArray1Sub.id,
                "topic": this.state.itemSelectedArray1Sub == null ? this.state.itemSelectedArray1.name : this.state.itemSelectedArray1Sub.name,
                "topiccateId": this.state.itemSelectedArray1 == null ? null : this.state.itemSelectedArray1.id,
                "topiccate": this.state.itemSelectedArray1 == null ? null : this.state.itemSelectedArray1.name,
                "description": this.state.description,
                "place": this.state.itemSelectedArray2Sub == null ? null : this.state.itemSelectedArray2Sub.id,
                "placeName": this.state.itemSelectedArray2Sub == null ? null : this.state.itemSelectedArray2Sub.name,                // "person": this.state.name,
                "person": stringListName,
                /*     "image": this.state.pathImage,
                     "video": this.state.pathVideo,
                     "category": this.state.Category.value,
                     "subject": this.state.CategoryType.value,
                     "description": this.state.description,
                     "address": this.state.address,
                     "longitude": this.props.route.params.position.long,
                     "latitude": this.props.route.params.position.lat,*/


                //"token_fb": this.props.DataSplashScreen.token_fb,
            };


            this.props.callService(
                typeExport.urlSetRegisterComplaintsScreen,
                paramss,
                typeExport.TypeSetRegisterComplaintsScreen,
                "POST",
                token
            );
            //this.GoScreen()


        } else {
            let listMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyRegisterComplaintsOffline + item.type);

            let data = {
                "_operation": typeExport._Contacts,
                "mode": "SaveComplaint",
                "lang": i18n.locale,
                "token": token,
                "type": item.type,

                //  "topic": this.state.itemSelectedArray1.id,
                "topic": this.state.itemSelectedArray1Sub == null ? this.state.itemSelectedArray1.name : this.state.itemSelectedArray1Sub.name,
                // "ticket_title": this.state.itemSelectedArray1Sub.name,

                // "topiccate": this.state.itemSelectedArray1Sub&&this.state.itemSelectedArray1Sub.id?this.state.itemSelectedArray1Sub.id:this.state.itemSelectedArray1.id,
                "topiccate": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.name ? this.state.itemSelectedArray1Sub.name : this.state.itemSelectedArray1.name,

                "description": this.state.description,
                "place": this.state.itemSelectedArray2Sub == null ? null : this.state.itemSelectedArray2Sub.id,
                "placeName": this.state.itemSelectedArray2Sub == null ? null : this.state.itemSelectedArray2Sub.name,
                //۱  "person": this.state.name,
                "person": stringListName,


                /*   "image": this.state.pathImage,
                   "video": this.state.pathVideo,
                   "category": this.state.Category.value,
                   "subject": this.state.CategoryType.value,
                   "description": this.state.description,
                   "address": this.state.address,
                   "longitude": this.props.route.params.position.long,
                   "latitude": this.props.route.params.position.lat,*/
                "index": (listMyApply != null && listMyApply.length > 0) ? listMyApply.length + 1 : 1,
                "date": moment().format("jYYYY/jM/jD HH:mm:ss"),

                //"token_fb": this.props.DataSplashScreen.token_fb,
            };


            if (listMyApply != null && listMyApply.length > 0) {
                listMyApply.push(data)

            } else {
                listMyApply = [];
                listMyApply.push(data)
            }


            await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyRegisterComplaintsOffline + item.type, listMyApply)
            // this.props.callServiceListNotSendMyApply(listMyApply)
            store.dispatch(serviceActionListNotSendRegisterComplaints(listMyApply));
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.RequestSuccessfullyRegistered'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                            NavigationService.BackTo(1)

                            //    NavigationService.navigatereset("ApplyScreen", {item: item})
                        }
                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                        , style: 'cancel'
                    },

                ],
                {cancelable: true}
            )


        }


    }

    /*

        renderPage(pageData, pageId, layout) {
            return (
                <View style={{flex: 1}}>

                    <FlatList

                        //      numColumns={3}
                        //       data={this.pageDataArray1}
                        data={this.selectListInFlatlist(pageId,)}
                        renderItem={({item, index}) =>
                            <View
                                style={{
                                    flex: 1,
                                    marginHorizontal: moderateScale(4)
                                }}>
                                <Card>
                                    <CardItem cardBody style={{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}>
                                        <TouchableOpacity
                                            style={{
                                                //margin: 10,
                                                flex: 1,
                                                height: constants.WIDTH / constants.HEIGHT_IMAGE,
                                                flexDirection: 'row',
                                                // backgroundColor: '#ee6313',
                                                alignItems: 'center'

                                            }}
                                            onPress={() => {

                                                let selectItem = "selectItem_" + this.state.currentPage
                                                let selectIndex = "selectIndex_" + this.state.currentPage + index

                                                //   let nameState= I

                                                switch (this.state.currentPage) {
                                                    case 0:

                                                        this.setState(prevState => ({
                                                                [selectItem]: pageId,
                                                                [selectIndex]: index,
                                                                indexSelectedArray1: index,
                                                                itemSelectedArray1: item,

                                                                //pageDataArray1Sub:this.pageDataArray1[index]
                                                                // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                                                            }),
                                                            () => {

                                                                this.setState({currentPage: this.state.currentPage + 1})
                                                                //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
    //
                                                            }
                                                        )
                                                        break;

                                                    case 1:
                                                        this.setState(prevState => ({
                                                                [selectItem]: pageId,
                                                                [selectIndex]: index,
                                                                indexSelectedArray1Sub: index,
                                                                itemSelectedArray1Sub: item,
                                                                //  pageDataArray1Sub:this.pageDataArray1[index]
                                                                // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                                                            }),
                                                            () => {

                                                                this.setState({currentPage: this.state.currentPage + 1})
                                                                //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
    //
                                                            }
                                                        )
                                                        break;
                                                    case 2:
                                                        this.setState(prevState => ({
                                                                [selectItem]: this.state.currentPage,
                                                                [selectIndex]: index,
                                                                indexSelectedArray2: index,
                                                                itemSelectedArray2: item,
                                                                // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                                                            }),
                                                            () => {

                                                                this.setState({currentPage: this.state.currentPage + 1})
                                                                //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
    //
                                                            }
                                                        )
                                                        break;

                                                    case 3:
                                                        this.setState(prevState => ({
                                                                [selectItem]: this.state.currentPage,
                                                                [selectIndex]: index,
                                                                indexSelectedArray2Sub: index,
                                                                itemSelectedArray2Sub: item,
                                                                // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                                                            }),
                                                            () => {

                                                                this.setState({currentPage: this.state.currentPage + 1})
                                                                //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
    //
                                                            }
                                                        )
                                                        break;
                                                }

                                                /!* NavigationService.navigateParams((item.types && item.types.length > 0) ? "ChildChildSubCategoryScreen" : "PrivatizationsScreen", {
                                                     id: item.id,
                                                     ItemsSelect: {
                                                         item_Category: props.ItemsSelect.item_Category,
                                                         item_SubCategory: props.ItemsSelect.item_SubCategory,
                                                         item_ChildSubCategory: item
                                                     }
                                                 })*!/

                                            }

                                            }
                                        >
                                            <View style={{

                                                width: moderateScale(50),
                                                height: moderateScale(50)
                                            }}>

                                                {/!*  <SvgUri
                                                    //   width={moderateScale(50)}
                                                    //   height={moderateScale(50)}
                                                    //  source={{uri: item.image}}
                                                    source={{uri: "http://portal.arak.ir/storage/2019/June/week3/complaintmessage_tks_topiccate_2_complaint.svg"}}
                                                />
    *!/}
                                                {/!*   <HMImageView
                                                    _svg
                                                    uriComplete={item.image}
                                                    styleText={{marginTop: moderateScale(10)}}
                                                    styleShadoBackground={{borderRadius: moderateScale(7)}}
                                                />*!/}
                                            </View>
                                            <HMTextView
                                                type={'bold'}
                                                text={item.title}
                                                style={{
                                                    color: Colors.blackLight,
                                                    marginEnd: moderateScale(10),
                                                    fontSize: moderateScale(12),
                                                }}/>
                                        </TouchableOpacity>
                                    </CardItem>
                                </Card>
                            </View>
                        }
                    />
                    {/!*   <View
                        style={{flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#ccc'}}>
                        <Text>{pageId + ' ' + pageData}</Text>
                    </View>*!/}
                </View>
            );
        }
    */
    handleScroll(event) {
    }

    render() {
        let textButtonNext = this.state.currentPage === 4 ? i18n.t('constant.Registration') : i18n.t('constant.next')
        let {item} = this.props.route.params

        return (
            <View style={styles.container}>
                <HMActionBar menu
                             props={this.props} statusBarTransparent
                    // text={i18n.t('Privatizations.title')}
                             text={item.title}
                             headerVisibility
                             more_menu
                             back
                             onBackPress={() => this.props.navigation.pop()}

                />
                <View style={styles.stepIndicator}>
                    <Steps
                        configs={firstIndicatorConfigs}
                        current={this.state.currentPage}
                        // reversed={true}
                        // labels={this.pageDataArray}
                    />
                </View>
                {/*     <View style={styles.stepIndicator}>
                    <Steps
                        renderStepIndicator={this.renderStepIndicator}
                        configs={secondIndicatorConfigs}
                        current={this.state.currentPage}
                        labels={[
                            'Cart',
                            'Delivery Address',
                            'Order Summary',
                            'Payment Method',
                            'Track'
                        ]}
                    />
                </View>
                <View style={styles.stepIndicator}>
                    <Steps
                        count={4}
                        configs={thirdIndicatorConfigs}
                        current={this.state.currentPage}
                        labels={['Approval', 'Processing', 'Shipping', 'Delivery']}
                    />
                </View>*/}
                {/*                <ViewPager
                    style={{flexGrow: 1,flexDirection: 'row-reverse'}}
                    ref={viewPager => {
                        this.viewPager = viewPager
                    }}
                    onPageSelected={page => {
                        this.setState({currentPage: page.position})
                    }}
                >
                    {PAGES.map((page, index) => this.renderViewPagerPage(page, index))}
                </ViewPager>*/}

                {/*         <ViewPager
                    ref={viewPager => {
                        this.viewPager = viewPager
                    }}
                    style={{flex: 1}}
                    renderPage={(pageData, pageId, layout) => {
                    }}
                    pageDataArray={['Account', 'Profile', 'Band', 'Membership', 'Dashboard']}
                    onPageSelected={page => {
                        this.setState({currentPage: page.position})
                    }}
                />*/}

                <View style={{flex: 1}}>

                    <View style={{flex: 1}}>
                        <FlatList
                            ref={(ref) => {
                                this.list = ref;
                            }}
                            onScroll={(e) => this.handleScroll(e)}
                            //      numColumns={3}
                            //       data={this.pageDataArray1}
                            data={this.selectListInFlatlist(this.state.currentPage)}
                            // data={this.selectListInFlatlist(this.state.currentPage)}
                            keyExtractor={(item, index) => item.svg}
                            renderItem={({item, index}) => {
                                return <HMItemCategory
                                    selectTick={container.selectTick}
                                    currentPage={this.state.currentPage}
                                    item={item} index={index}
                                    onPress={
                                        () => container.goNext(item, index)
                                    }/>
                            }

                            }
                        />
                        {
                            this.state.currentPage != 4 ?
                                null
                                :
                                <View
                                    style={{
                                        position: 'absolute',
                                        flex: 1,
                                        // height:'100%',
                                        // alignContent: 'center',
                                        // alignItems: 'center',
                                        //  justifyContent: 'center',

                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(0,0,0,0.01)',
                                        zIndex: 999
                                    }}>
                                    <View style={{marginHorizontal: moderateScale(8)}}>
                                        <FlatList
                                            style={{height: moderateScale(30)}}
                                            // data={data.results.all_categories}
                                            data={this.state.listName}
                                            renderItem={({item, index}) =>

                                                <View
                                                    onPress={() => {

                                                    }
                                                    }
                                                    style={{
                                                        paddingHorizontal: moderateScale(3),
                                                        backgroundColor: Colors.colorPrimary,
                                                        borderRadius: moderateScale(4),
                                                        marginHorizontal: moderateScale(2)
                                                    }}
                                                >
                                                    <View style={[{
                                                        //marginVertical: moderateScale(15),
                                                        height: moderateScale(30),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexDirection: 'row'
                                                    }]}>
                                                        {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                                        {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                                                        <HMTextView text={item} type={"bold"}
                                                                    style={{
                                                                        color: Colors.white,
                                                                        marginHorizontal: moderateScale(6),
                                                                        fontSize: moderateScale(11),
                                                                        textAlign: 'center'
                                                                    }}/>
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                var array = [...this.state.listName]; // make a separate copy of the array

                                                                array.splice(index, 1);
                                                                this.setState({listName: array});


                                                                /*    let arr= this.state.listName
                                                                    this.setState({
                                                                        listName: arr.splice(index, 1)
                                                                    })*/
                                                            }}
                                                            style={{alignSelf: 'center'}}>
                                                            <HMIcon name={"md-close"} style={{
                                                                fontSize: moderateScale(14),
                                                                color: '#f2f2f2'
                                                            }}/>
                                                        </TouchableOpacity>


                                                    </View>
                                                    {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

                                                </View>
                                            }
                                            horizontal={true}
                                            showsHorizontalScrollIndicator={false}
                                            keyExtractor={(item, index) => index.toString()}
                                            inverted={true}
                                        />

                                    </View>

                                    <HMTextInput
                                        value={this.state.name}

                                        onChangeText={text => {
                                            this.setState({name: text})
                                        }} autoFocus
                                        //       keyboardType="numeric"
                                        placeholder={i18n.t('constant.checkFirstName')}
                                        style={{
                                            // width: "90%",
                                            fontSize: moderateScale(14)
                                        }} underlineColorAndroid="transparent"
                                        onSubmitEditing={() => {
                                            var array = [...this.state.listName]; // make a separate copy of the array
                                            array.push(this.state.name);
                                            this.setState({listName: array, name: ''});


                                        }}
                                        containerStyle={{
                                            //marginHorizontal: moderateScale(8),
                                            borderWidth: 1,
                                            borderRadius: 2,
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {width: 0, height: 2},
                                            shadowOpacity: 0.8,
                                            shadowRadius: 2,
                                            elevation: 1,
                                            marginLeft: 5,
                                            marginRight: 5,
                                            marginTop: moderateScale(5),

                                        }}

                                    />


                                    <HMTextInput
                                        value={this.state.description}
                                        _multiline
                                        onChangeText={text => {
                                            this.setState({description: text})
                                        }}
                                        autoFocus
                                        styleInput={{height: moderateScale(80)}}
                                        //   keyboardType="numeric"
                                        placeholder={i18n.t('constant.PlaceholderDesc')}
                                        style={{
                                            // width: "90%",
                                            // height:moderateScale(100),
                                            fontSize: moderateScale(14)
                                        }} underlineColorAndroid="transparent"
                                        containerStyle={{
                                            //marginHorizontal: moderateScale(8),
                                            borderWidth: 1,
                                            borderRadius: 2,
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {width: 0, height: 2},
                                            shadowOpacity: 0.8,
                                            shadowRadius: 2,
                                            elevation: 1,
                                            marginLeft: 5,
                                            marginRight: 5,
                                            marginTop: moderateScale(5),
                                        }}
                                        textCenter={'center'}
                                    />


                                </View>
                        }


                    </View>
                    {/* <ViewPager
                        ref='viewPager'
                        style={{flex: 1, backgroundColor: 'white'}}
                        renderPage={this.renderPage.bind(this)}
                        pageDataArray={this.pageDataArray}
                        initialPage={0}
                        pageMargin={20}
                        scrollEnabled={true}
                        onPageScroll={(e) => {
                        }}
                        onPageScrollStateChanged={(state) => {
                        }}
                        onPageSelected={(page) => {
                            this.setState({currentPage: page})

                        }}

                    />*/}
                    <View
                        style={{
                            width: '100%',
                            height: moderateScale(42),
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: moderateScale(8)
                        }}>
                        {


                            <View
                                style={{
                                    width: '100%',
                                    height: moderateScale(42),
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: moderateScale(8)
                                }}
                            >
                                <TouchableOpacity
                                    onPress={() => {
                                        // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                        //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                        this.goBack();
                                    }}
                                    style={{
                                        flex: .48,
                                        height: moderateScale(42),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.colorPrimary,
                                        borderRadius: moderateScale(6)

                                    }}>

                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={i18n.t('constant.Back')} type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(6),
                                            marginHorizontal: moderateScale(4),
                                            color: Colors.white
                                        }}/>
                                </TouchableOpacity>

                                <View style={{width: moderateScale(8)}}/>
                                <TouchableOpacity

                                    onPress={() => {
                                        //   this.refs['viewPager'].setPage(this.state.currentPage + 1);
                                        if (this.state.currentPage <= 3) {
                                            // indexSelectedArray1: -1,
                                            //     itemSelectedArray1: null,
                                            //
                                            //     itemSelectedArray1Sub: null,
                                            //     indexSelectedArray1Sub: -1,
                                            //
                                            //     indexSelectedArray2: -1,
                                            //     itemSelectedArray2: null,
                                            //
                                            //
                                            //     indexSelectedArray2Sub: -1,
                                            //     itemSelectedArray2Sub: null,

                                            if (this.state.currentPage == 0 && this.state.indexSelectedArray1 == -1)
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            else if (this.state.currentPage == 1 && this.state.indexSelectedArray1Sub == -1) {
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            } else if (this.state.currentPage == 2 && this.state.indexSelectedArray2 == -1) {
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            } else if (this.state.currentPage == 3 && this.state.indexSelectedArray2Sub == -1) {
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            } else
                                                this.setState({
                                                        typeButton: "next",
                                                        currentPage: this.state.currentPage + 1
                                                    }
                                                    , () => {

                                                    }
                                                )
                                        } else {


                                            this.setData()
                                        }


                                    }}
                                    style={{
                                        flex: .48,
                                        height: moderateScale(42),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.colorPrimary,
                                        borderRadius: moderateScale(6)
                                    }}>
                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={textButtonNext} type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(6),
                                            marginHorizontal: moderateScale(4),
                                            color: Colors.white
                                        }}/>
                                </TouchableOpacity>
                            </View>

                        }


                    </View>
                </View>
                {
                    this.props.NoInternetDialog ?
                        <DialogConnectionCustomize
                            onPress={() => this.setData()}
                        />
                        :
                        null
                }
                {
                    this.props.isLoading || this.props.isLoadingSet ?
                        <DialogLoadingCustomize
                        />
                        : null
                }
            </View>
        )
    }

    goNext(item, index) {
        /*     let arr=this.CheckListInFlatlist(this.state.currentPage + 1,index);
                                                if(arr&&arr.length>0){*/
        let selectItem = "selectItem_" + index
        let selectIndex = "selectIndex_" + index

        //   let nameState= I

        switch (container.state.currentPage) {
            case 0:


                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1: index,
                        itemSelectedArray1: item,

                        itemSelectedArray1Sub: null,
                        indexSelectedArray1Sub: -1,
                        // itemSelectedArray1Sub: item.subjects[0],
                        // indexSelectedArray1Sub: 0,
                        typeButton: "next",
                        currentPage: container.state.currentPage + 1
                        //pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {
                        setTimeout(function () {
                            //  container.setState({timePassed: true})

                            try {
                                container.list.scrollToIndex({
                                    animated: true,
                                    index: Platform.OS === 'android' ? 0 : 0
                                })

                            } catch (e) {

                            }

                            // alert("df")
                        }, 400)
                        //  container.list.scrollToIndex({animated: true, index: 0})
                        //   container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;

            case 1:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1Sub: index,
                        itemSelectedArray1Sub: item,
                        typeButton: "next"
                        //  pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;
            case 2:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray2: index,
                        itemSelectedArray2: item,

                        //   itemSelectedArray2Sub: item.subplaces[0],
                        // indexSelectedArray2Sub: 0,

                        itemSelectedArray2Sub: null,
                        indexSelectedArray2Sub: -1,
                        typeButton: "next"
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;

            case 3:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray2Sub: index,
                        itemSelectedArray2Sub: item,
                        typeButton: "next"
                        //pageDataArray1Sub: container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;
        }
        /*    }
            else {
                container.setState({currentPage: container.state.currentPage + 2})
            }
    */

        /* NavigationService.navigateParams((item.types && item.types.length > 0) ? "ChildChildSubCategoryScreen" : "PrivatizationsScreen", {
             id: item.id,
             ItemsSelect: {
                 item_Category: props.ItemsSelect.item_Category,
                 item_SubCategory: props.ItemsSelect.item_SubCategory,
                 item_ChildSubCategory: item
             }
         })*/

    }

    selectListInFlatlist(index) {
        let d = null
        switch (index) {
            case 0:
                d = this.pageDataArray1

                this.nextEmpty(d, this.state.indexSelectedArray1)

                return d

            case 1:
                d = this.pageDataArray1[this.state.indexSelectedArray1].subjects
                this.nextEmpty(d, this.state.indexSelectedArray1Sub)
                return d

            case 2:
                d = this.pageDataArray2
                this.nextEmpty(d, this.state.indexSelectedArray2)
                return d


            case 3:

                // d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                this.nextEmpty(d, this.state.indexSelectedArray2Sub)
                return d


        }
    }

    goToIndex(index) {
        setTimeout(function () {
            //  this.setState({timePassed: true})
            //  if (index > 6)
            try {
                container.list.scrollToIndex({animated: true, index: index});

            } catch (e) {

            }
            // alert("df")
        }, 400)
        /*    setTimeout(function(){

                //Put All Your Code Here, Which You Want To Execute After Some Delay Time.
                HMAlert("Alert Shows After 5 Seconds of Delay.")

            }, 1000);*/
    }

    nextEmpty(data, index) {

        if (data && data.length > 0) {

            this.goToIndex(index)
        } else {
            this.setState({
                    currentPage: this.state.typeButton === "next" ? this.state.currentPage + 1 : this.state.currentPage - 1
                },
                () => {

                })
        }

    }

    CheckListInFlatlist(page, index) {
        switch (page) {
            case 0:

                return this.pageDataArray1

            case 1:
                return this.pageDataArray1[index].subjects

            case 2:
                return this.pageDataArray2


            case 3:

                return this.pageDataArray2[index].subplaces


        }
    }

    selectTick(index) {
        switch (container.state.currentPage) {
            case 0:

                return container.state.indexSelectedArray1 == index

            case 1:

                return container.state.indexSelectedArray1Sub == index
            case 2:

                return container.state.indexSelectedArray2 == index

            case 3:


                return container.state.indexSelectedArray2Sub == index

        }
    }


}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#ffffff'
    },
    stepIndicator: {
        marginVertical: moderateScale(6)
    },
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    }
});
